import React from 'react';
import styles from './consultancyStep.module.css';

interface StepImageProps {
  src: string;
  alt: string;
  objectPosition?: string;
  rightCropPx?: number;
}

const StepImage: React.FC<StepImageProps> = ({
  src,
  alt,
  objectPosition,
  rightCropPx,
}) => (
  <div className={styles.imageColumn}>
    <img
      className={`${styles.stepImage}${rightCropPx ? ` ${styles.stepImageRightCrop}` : ''}`}
      src={src}
      alt={alt}
      style={{
        ...(objectPosition ? { objectPosition } : {}),
        ...(rightCropPx
          ? ({ '--step-image-right-crop': `${rightCropPx}px` } as React.CSSProperties)
          : {}),
      }}
    />
  </div>
);

export default StepImage;
